import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import CommonInput from '../../Components/CommonInput';
import CommonButton from '../../Components/CommonButton';
import ButtonLoader from '../../Components/ButtonLoader';
import { domain_addition_request } from '../../services';

function AddDomainModal(props) {
    const { onHide, onSuccess } = props;
    const [resMsg, setResMsg] = useState("");
    const [msgType, setMsgType] = useState(""); // 'success' or 'error'
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        domain_name: "",
        user_justification: "",
    });

    // Validation function
    const validate = () => {
        const newErrors = {};

        if (!formData.domain_name || formData.domain_name.trim() === "") {
            newErrors.domain_name = "Domain name is required.";
        }

        if (!formData.user_justification || formData.user_justification.trim() === "") {
            newErrors.user_justification = "User justification is required.";
        } else if (formData.user_justification.trim().length < 1) {
            newErrors.user_justification = "User justification must be at least 1 character.";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    // Handle input change
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
        setErrors((prev) => ({ ...prev, [name]: "" }));
    };

    // Submit handler
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validate()) return;
        setLoading(true);
        setResMsg("");
        setMsgType("");

        const payload = {
            domain_name: formData.domain_name.trim(),
            user_justification: formData.user_justification.trim(),
        };

        try {
            const response = await domain_addition_request(payload);
            const responseData = response?.statusCode?.response_data;
            const errorMessage = response?.statusCode?.error?.message;

            if (errorMessage) {
                setResMsg(errorMessage);
                setMsgType("error");
            } else if (responseData) {
                const { message } = responseData;
                if (message || responseData) {
                    setResMsg(message || "Domain added successfully!");
                    setMsgType("success");
                    // Close modal and refresh after showing success message
                    setTimeout(() => {
                        onHide && onHide();
                        onSuccess && onSuccess();
                    }, 1500);
                } else {
                    setResMsg(errorMessage || "Failed to add domain");
                    setMsgType("error");
                }
            } else {
                setResMsg(errorMessage || "Failed to add domain");
                setMsgType("error");
            }
        } catch (err) {
            console.error("Failed to add domain:", err);
            const errorMsg = err?.response?.data?.message || err?.message || "Failed to add domain";
            setResMsg(errorMsg);
            setMsgType("error");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal
            {...props}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            className="cstm_modal white_border"
            onHide={onHide}
        >
            <Modal.Header closeButton>
                <Modal.Title>Add Domain</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <form className="add_domain_modal_form p-3" onSubmit={handleSubmit} noValidate>
                    {/* Domain Name */}
                    <div className="form-group mb-4">
                        <label className='text-white'>Domain Name <span>*</span></label>
                        <CommonInput
                            name="domain_name"
                            placeholder="Enter domain name"
                            value={formData.domain_name}
                            onChange={handleInputChange}
                        />
                        {errors.domain_name && <small className="text-danger">{errors.domain_name}</small>}
                    </div>

                    {/* User Justification */}
                    <div className="form-group mb-4">
                        <label className='text-white'>User Justification <span>*</span></label>
                        <textarea
                            name="user_justification"
                            placeholder="Enter your justification for adding this domain"
                            value={formData.user_justification}
                            onChange={handleInputChange}
                            rows={5}
                            className="form-control"
                        />
                        {errors.user_justification && <small className="text-danger">{errors.user_justification}</small>}
                    </div>

                    {/* Response Message */}
                    {resMsg && (
                        <div className={`mb-3 p-3 rounded ${msgType === 'success' ? 'text-success bg-light' : 'text-danger bg-light'}`}>
                            {resMsg}
                        </div>
                    )}

                    <div className="form-group mt-4">
                        <CommonButton
                            type="submit"
                            text={loading ? <ButtonLoader /> : "Submit"}
                            className="blue_btn"
                            disabled={loading}
                        />
                    </div>
                </form>
            </Modal.Body>
        </Modal>
    );
}

export default AddDomainModal;

